<script setup lang="ts">
import AppModal from './AppModal.vue';
import { useI18n } from 'vue-i18n';
import ProjectHoldForm from '@/components/ProjectHoldForm.vue';
import { VCardText } from 'vuetify/components';
import type { ProjectHoldFormValues } from '@/components/ProjectHoldForm.vue';

const { t } = useI18n({
    inheritLocale: true,
    messages: {
        nl: {
            title: '@:project on-hold zetten',
        },
        en: {
            title: 'Put @.lower:project on-hold',
        },
    },
});

const isShowing = defineModel<boolean>({ default: false });

defineProps<{
    projectId: string; // eslint-disable-line vue/no-unused-properties -- needed once backend supports hold reason
}>();

const emit = defineEmits<{
    submit: [values: ProjectHoldFormValues];
}>();

function onSubmit(values: ProjectHoldFormValues) {
    emit('submit', values);
}

function onCancel() {
    isShowing.value = false;
}
</script>

<template>
    <AppModal
        v-model="isShowing"
        :title="t('title')"
        :width="744"
        height="auto"
        persistent
    >
        <VCardText>
            <ProjectHoldForm @submit="onSubmit" @cancel="onCancel" />
        </VCardText>
    </AppModal>
</template>
